"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TagList", {
  enumerable: true,
  get: function get() {
    return _TagList["default"];
  }
});
Object.defineProperty(exports, "Tag", {
  enumerable: true,
  get: function get() {
    return _Tag["default"];
  }
});

var _TagList = _interopRequireDefault(require("./js/TagList"));

var _Tag = _interopRequireDefault(require("./js/Tag"));